module.exports = __webpack_public_path__ + "img/life.c9d2117d.svg";